<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Email Verification Statuses</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<hr class="m-0 p-0">
<mat-dialog-content>
  <div class="mb-3">
    <p class="mb-2">The status is calculated from each user's verification deadline.</p>
    <p class="mb-2">Only a passed deadline blocks sign-in. Being unverified before the deadline does not.</p>
    <p class="mb-2">Verification is renewed every 12 months. Reminder emails are sent 7 days and 1 day before the deadline.</p>
    <p class="mb-2">Re-verification pending is shown for the first 30 days after a missed deadline when a reminder had been sent. After that it becomes Expired. Both block sign-in the same way.</p>
    <p class="mb-0 small text-muted">The 12 months, 7 days, 1 day and 30 days above are the current defaults and can be changed in the server configuration.</p>
  </div>
  <div class="legend-row mb-3 pb-3 border-bottom" *ngFor="let key of order">
    <div class="d-flex align-items-center mb-2">
      <mat-icon
        class="mr-1"
        aria-hidden="true"
        [color]="displays[key].color"
        [class.verification-neutral]="!displays[key].color">{{ displays[key].icon }}</mat-icon>
      <div class="d-flex flex-column">
        <span class="verification-label">{{ displays[key].label }}</span>
        <span class="verification-sub-label text-danger" *ngIf="displays[key].blocksSignIn">Sign-in blocked</span>
      </div>
    </div>
    <div class="small">
      <div class="mb-1"><span class="font-weight-bold">When it appears: </span>{{ appText(displays[key].legend.appears) }}</div>
      <div class="mb-1"><span class="font-weight-bold">Sign-in: </span>{{ appText(displays[key].legend.signIn) }}</div>
      <div class="mb-1"><span class="font-weight-bold">Who it applies to: </span>{{ appText(displays[key].legend.appliesTo) }}</div>
      <div><span class="font-weight-bold">How it clears: </span>{{ appText(displays[key].legend.clears) }}</div>
    </div>
  </div>
</mat-dialog-content>
<hr class="m-0 p-0">
<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button mat-dialog-close>Close</button>
  </div>
</mat-dialog-actions>
